export default "__VITE_ASSET__195a1673__"